import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "whitespace-nowrap inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        // Default primary badge
        default:
          "border-transparent bg-primary text-primary-foreground shadow-sm",

        // Secondary subtle badge
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",

        // Destructive / Error
        destructive:
          "border-transparent bg-destructive/10 text-destructive",

        // Success
        success:
          "border-transparent bg-success/10 text-success",

        // Warning
        warning:
          "border-transparent bg-warning/10 text-warning-foreground",

        // Info
        info:
          "border-transparent bg-info/10 text-info",

        // Outline
        outline:
          "border-2 border-current bg-transparent",

        // Premium gold badge
        premium:
          "border-transparent bg-gradient-to-r from-amber-400 to-orange-500 text-slate-900 shadow-md font-bold",

        // Glow badge
        glow:
          "border-transparent bg-primary text-primary-foreground shadow-glow-primary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants }
